import { useState, useEffect, useContext } from "react";
import PageTitle from "../../../components/PageTitle/PageTitle";
import "./ApiKeys.scss";
import { AuthContext } from "../../../contexts/AuthContext";
import Table from "../../../components/Table/Table";

export default function ApiKeys() {
  const { axiosAuth, accessibleGroups } = useContext(AuthContext);
  const [apiList, setApiList] = useState([]);

  useEffect(() => {
    try {
      axiosAuth.get("/api-keys").then(({ data }) => {
        setApiList(data);
      });
    } catch (err) {
      console.error("Erro ao puxar api keys list:", err.message);
    }
  }, []);

  const columns = [
    { key: "id", label: "ID do grupo" },
    { key: "name", label: "Nome do grupo" },
    { key: "raw_key", label: "Api key" },
  ];

  const tableData = accessibleGroups.map((group) => {
    const apiKey = apiList.find((k) => k.id === group.id);
    return {
      id: group.id,
      name: group.name,
      raw_key: apiKey ? apiKey.raw_key : "-",
    };
  });

  return (
    <div className="api-keys">
      <PageTitle link="" title="Chaves API clientes" />
      <div className="container">
        <Table columns={columns} data={tableData} />
      </div>
    </div>
  );
}
